import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var errorIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.17 17.15a1.15 1.15 0 1 1-2.3 0 1.15 1.15 0 0 1 2.3 0zM10.893 6.138c.347-.086 1.51-.204 1.79-.033a.984.984 0 0 1 .457.776l.09 7.95c-.347.086-1.64.207-1.92.036a.984.984 0 0 1-.457-.776z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "11",
  stroke: "currentColor",
  strokeWidth: "2"
})));

export { errorIcon as default };
//# sourceMappingURL=errorIcon.js.map
